module.exports = __webpack_public_path__ + "static/media/editGrey.79df8044.svg";